module.exports = __webpack_public_path__ + "img/20200115155554171.baa1e861.jpg";